import { RadioField } from '../../checkbox-or-radio-field';
import { FormattedMessage } from 'react-intl';

export const SortingForm = () => {
  return (
    <>
      <RadioField
        id="mobileFilter.ascName"
        name="sort"
        value="ascName"
        label={<FormattedMessage id="mobileFilter.name.label" defaultMessage="By Name (A-Z)" />}
        hidefeedback="true"
      />
      <RadioField
        id="mobileFilter.descName"
        name="sort"
        value="descName"
        label={<FormattedMessage id="mobileFilter.descName.label" defaultMessage="By Name (Z-A)" />}
        hidefeedback="true"
      />
      <RadioField
        id="mobileFilter.access.myTeam"
        name="sort"
        value="accessMyTeam"
        label={<FormattedMessage id="mobileFilter.access.myTeam.label" defaultMessage="By Access (My Team on top)" />}
        hidefeedback="true"
      />
      <RadioField
        id="mobileFilter.access.private"
        name="sort"
        value="accessPrivate"
        label={<FormattedMessage id="mobileFilter.access.private.label" defaultMessage="By Access (Private on top)" />}
        hidefeedback="true"
      />
    </>
  );
};
